import {
  Component,
  Inject,
  Input,
  HostListener,
  ViewEncapsulation,
  Renderer2,
  Output,
  EventEmitter
} from '@angular/core';
import { IAppState } from '@app/store';
import { Store } from '@ngrx/store';
import { environment } from '@env/environment';
import { IsLoggedGuard } from '@app/shared/guards';
import { HeaderBadgeDetail } from '@vestiaire/api-sdk-angular';
import * as HeaderActions from '@app/core/header/store/actions/header.action';
import { ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'vc-user-accesses',
  templateUrl: './user-accesses.component.html',
  styleUrls: ['./user-accesses.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserAccessesComponent {
  @Input() isLogged: any;
  @Input() userInfo: any;
  @Input() userWallet: any;
  @Input() headerBadgeDetail: HeaderBadgeDetail;
  @Input() needGetPaidAction: boolean;
  public previewBox__profile_right_pos = 0;
  public previewBox__notif_right_pos = 0;
  public imgixPath: string;

  // The two following var MUST be removed after the full release of the newsfeed
  public isFeedEnabled: boolean;
  @Output() openMainNav = new EventEmitter<any>();

  public defaultBoxes = {
    isProfilePreviewOpened: false,
    isNotifPreviewOpened: false
  };
  public boxes = {
    isProfilePreviewOpened: false,
    isNotifPreviewOpened: false
  };
  public url: string;
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private store: Store<IAppState>,
    private loggedGuard: IsLoggedGuard,
    @Inject(DOCUMENT) private document,
    private element: ElementRef,
    private renderer: Renderer2
  ) {
    this.imgixPath = environment.imgixPath;
    this.isFeedEnabled = environment.feature.newsfeed;
    this.getUrl();
  }

  getUrl(): void {
    this.store
      .select('router')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.state && res.state.url) {
            this.url = res.state.url;
          }
        },
        error => console.log(error)
      );
  }

  closeBoxes(eventValue) {
    if (eventValue) {
      this.closePreviewBox();
    }
  }

  togglePreviewBox(actionName: string, payload: boolean, type: string, needLogin: boolean = false) {
    if (needLogin && !this.loggedGuard.isLoggedIn()) {
      return;
    }
    const obj = {};
    obj[actionName] = payload;
    this.boxes = { ...this.defaultBoxes, ...obj };
    if (payload && type) {
      this.setPreviewBoxPosition(type);
      this.renderer.removeClass(this.element.nativeElement.children[0], 'tabActiveOn');
    }
  }

  @HostListener('document:click', ['$event'])
  handleClick(event: Event) {
    if (!this.element.nativeElement.contains(event.target)) {
      this.closePreviewBox();
    }
  }

  closePreviewBox() {
    this.boxes = this.defaultBoxes;
    this.renderer.addClass(this.element.nativeElement.children[0], 'tabActiveOn');
  }

  setPreviewBoxPosition(type) {
    const iconElem = this.document.getElementsByClassName('userAccess__item--' + type);
    const iconPos = iconElem[0] ? iconElem[0].getBoundingClientRect() : {};
    const userAccessesElem = this.document.getElementsByClassName('mainHeader__userAccess');
    const userAccessesPos = userAccessesElem[0] ? userAccessesElem[0].getBoundingClientRect() : {};

    const deltaAlignment = 21.5 - iconPos.width / 2; // to align middle of the arrow with middle of icon

    const rightPos = (userAccessesPos.right - iconPos.right || 0) - deltaAlignment;
    this['previewBox__' + type + '_right_pos'] = rightPos + 'px';
  }

  trackHeaderButtonClick(buttonName) {
    this.store.dispatch({
      type: HeaderActions.CLICK_ON_HEADER_BUTTON,
      payload: {
        button_name: buttonName
      }
    });
  }
}
